<thm-notification></thm-notification>
<thm-wrapper>
  <router-outlet></router-outlet>
</thm-wrapper>
